import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import DELETE_NAVSLOT_MUTATION from '../queries/DELETE_NAVSLOT_MUTATION';
import NAVSLOTS_QUERY from '../queries/NAVSLOTS_QUERY';
import Loading from '../../../common/Loading';
import EDIT_NAVSLOT_MUTATION from '../queries/EDIT_NAVSLOT_MUTATION';
import apolloClient from '../../../utils/apolloClient';

const NavSlotListItem = (props: any) => {
    const navSlot = props.navSlot;
    const navigate = useNavigate();
    const [editing, setEditing]: [boolean, Function] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [deleteSlot, { loading: deleteLoading }] = useMutation(DELETE_NAVSLOT_MUTATION, {
        variables: {
            navSlotId: navSlot.id,
        },
        onCompleted: (res) => {
            setDeleting(false);
            const slot = res.deleteNavSlot;
            const data = apolloClient.readQuery({ query: NAVSLOTS_QUERY });
            const navigations = data.navigations.filter((n: any) => n.id !== slot.id);
            apolloClient.writeQuery({
                query: NAVSLOTS_QUERY,
                data: {
                    navigations: [...navigations],
                },
            });
        }
    });
    const [editSlot, { loading: editLoading }] = useMutation(EDIT_NAVSLOT_MUTATION, {
        variables: {
            navSlotData: {
                id: navSlot.id,
            },
        },
        onCompleted: (res) => {
            setEditing(false);
        },
        refetchQueries: [
            {
                query: NAVSLOTS_QUERY,
            }
        ]
    });

    const renderModal = () => {
        if (deleting) {
            return (<tr>
                <th>Delete Nav Slot?</th>
                <td colSpan={1000}>
                    You are deleting <strong>{navSlot.name}</strong>
                    {!deleteLoading ? <Button variant="danger" className="ms-2" size="sm" onClick={() => deleteSlot()}>Delete</Button> : <Loading label="&nbsp; Deleting" />}
                </td>
            </tr>);
        }
        if (editing) {
            return (<tr>
                <th>Edit Nav Slot?</th>
                <td colSpan={1000}>
                    {!editLoading ? <Button variant="primary" className="ms-2" size="sm" onClick={() => editSlot()}>Edit</Button> : <Loading label="&nbsp; Editing" />}
                </td>
            </tr>);
        }
        return null;
    }
    return (<>
        <tr>
            <th scope="row">{navSlot.slug}</th>
            <td>{navSlot.name}</td>
            <td>{navSlot.description}</td>
            <td className="text-center"><FontAwesomeIcon color="#B41D15" style={{ cursor: "pointer" }} icon="trash-alt" onClick={() => setDeleting(!deleting)} /></td>
            <td className="text-center"><FontAwesomeIcon color="#868e96" style={{ cursor: "pointer" }} icon="edit" onClick={() => navigate(`/admin/edit-nav/${navSlot.slug}`)} /></td>
        </tr>
        {renderModal()}
    </>);
};

export default NavSlotListItem;
